module.exports = __webpack_public_path__ + "img/相似度定义统计.8c1249e4.svg";